import React from 'react';
import Skeleton from '../Skeleton';
import './internalDataSkeleton.css';

const InternalDataSkeleton = ({
  text = 'Carregando dados do interno...',
  blocks = 3,
  lines = 4,
  className = '',
  prefix = 'internal-data-skeleton',
}) => (
  <div className={`internal-data-skeleton ${className}`.trim()}>
    {Array.from({ length: blocks }).map((_, index) => (
      <div key={`${prefix}-block-${index}`} className="internal-data-skeleton__block">
        <Skeleton
          type="stack"
          lines={lines}
          text={index === 0 ? text : ''}
          prefix={`${prefix}-stack-${index}`}
        />
      </div>
    ))}
  </div>
);

export default InternalDataSkeleton;
